import { CalendarRepeatMode } from "@/store/api";
import { MONTHS_LIST } from "@/tools/constants";
var WEEKDAY_TEXT = [
    "понедельникам",
    "вторникам",
    "средам",
    "четвергам",
    "пятницам",
    "субботам",
    "воскресеньям",
];
var MONTHS_IN = [
    "январе",
    "феврале",
    "марте",
    "апреле",
    "мае",
    "июне",
    "июле",
    "августе",
    "сентябре",
    "октябре",
    "ноябре",
    "декабре",
];
var WEEK_TEXT = ["1-й", "2-й", "3-й", "4-й", "последний"];
var joinWithAnd = function (items) {
    if (items.length === 0) {
        return "";
    }
    if (items.length === 1) {
        return items[0];
    }
    return "".concat(items.slice(0, -1).join(", "), " \u0438 ").concat(items[items.length - 1]);
};
var isChecked = function (formData, key) {
    return Boolean(formData[key]);
};
var formatDate = function (value) {
    return value ? value.format("DD.MM.YYYY") : "";
};
var appendRange = function (base, startDate, stopDate) {
    var result = base;
    if (startDate) {
        result = "".concat(result, ", \u043D\u0430\u0447\u0438\u043D\u0430\u044F \u0441 ").concat(startDate);
    }
    if (stopDate) {
        result = "".concat(result, ", \u0434\u043E ").concat(stopDate);
    }
    return result;
};
var getWeekDaysResult = function (formData) {
    var selectedWeekDays = WEEKDAY_TEXT.filter(function (_item, index) {
        return isChecked(formData, "wd".concat(index + 1));
    });
    if (selectedWeekDays.length === 5 &&
        [0, 1, 2, 3, 4].every(function (index) { return isChecked(formData, "wd".concat(index + 1)); })) {
        return "по будням";
    }
    if (selectedWeekDays.length === 0 || selectedWeekDays.length === 7) {
        return "каждый день";
    }
    return "\u043F\u043E ".concat(joinWithAnd(selectedWeekDays));
};
var getMonthResult = function (formData) {
    var selectedMonths = MONTHS_LIST.map(function (_item, index) { return index; }).filter(function (index) { return isChecked(formData, "m".concat(index + 1)); });
    if (selectedMonths.length === 0 || selectedMonths.length === 12) {
        return "каждый месяц";
    }
    return joinWithAnd(selectedMonths.map(function (index) { return "\u0432 ".concat(MONTHS_IN[index]); }));
};
var getCalendDaysResult = function (formData) {
    var selectedDays = Array.from({ length: 31 }, function (_item, index) { return index + 1; })
        .filter(function (day) { return isChecked(formData, "d".concat(day)); })
        .map(function (day) { return "".concat(day, " \u0447\u0438\u0441\u043B\u0430"); });
    if (isChecked(formData, "dLast")) {
        selectedDays.push("в последний день месяца");
    }
    if (selectedDays.length === 0) {
        return "каждый день";
    }
    return joinWithAnd(selectedDays);
};
var getWeeksResult = function (formData) {
    var selectedWeeks = WEEK_TEXT.filter(function (_item, index) {
        return index < 4
            ? isChecked(formData, "w".concat(index + 1))
            : isChecked(formData, "wLast");
    });
    if (selectedWeeks.length === 0 || selectedWeeks.length === 5) {
        return "";
    }
    return joinWithAnd(selectedWeeks.map(function (week) {
        return week === "последний"
            ? "в последний раз в месяце"
            : "\u0432 ".concat(week, " \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446\u0435");
    }));
};
/** Текстовое представление выбранных настроек расписания. */
export var getTextResult = function (formData) {
    var repeatType = formData.repeatMode[0];
    var startDate = formatDate(formData.startDate);
    var stopDate = formatDate(formData.stopDate);
    var repeatStep = Number(formData.repeatStep) || 1;
    if (repeatType === CalendarRepeatMode.Once) {
        return startDate ? "\u041E\u0434\u043D\u043E\u043A\u0440\u0430\u0442\u043D\u043E ".concat(startDate) : "Однократно";
    }
    if (repeatType === CalendarRepeatMode.Daily) {
        var result = repeatStep > 1
            ? "\u041F\u043E\u0432\u0442\u043E\u0440\u044F\u0442\u044C \u043A\u0430\u0436\u0434\u044B\u0439 ".concat(repeatStep, "-\u0439 \u0434\u0435\u043D\u044C")
            : "Повторять каждый день";
        return appendRange(result, startDate, stopDate);
    }
    if (repeatType === CalendarRepeatMode.Weekly) {
        var prefix = repeatStep > 1 ? "\u041F\u043E\u0432\u0442\u043E\u0440\u044F\u0442\u044C \u043A\u0430\u0436\u0434\u0443\u044E ".concat(repeatStep, "-\u044E \u043D\u0435\u0434\u0435\u043B\u044E") : "Повторять";
        return appendRange("".concat(prefix, " ").concat(getWeekDaysResult(formData)), startDate, stopDate);
    }
    if (repeatType === CalendarRepeatMode.Calenddays) {
        var result = [
            "Повторять",
            getMonthResult(formData),
            getCalendDaysResult(formData),
        ]
            .filter(Boolean)
            .join(" ");
        return appendRange(result, startDate, stopDate);
    }
    if (repeatType === CalendarRepeatMode.Weekdays) {
        var weeksResult = getWeeksResult(formData);
        var result = [
            "Повторять",
            getMonthResult(formData),
            weeksResult,
            getWeekDaysResult(formData),
        ]
            .filter(Boolean)
            .join(" ");
        return appendRange(result, startDate, stopDate);
    }
    return "";
};
